export const GlobalFilterRoute = {
  FILTERS: 'filters',
};

export const GlobalFilterPathName = {
  FILTERS: 'filters',
};
